<template>
  <div>
    <div class="history-time">
      {{ drawTime(timestamp) }}
    </div>
    <div class="history-date">
      {{ drawDate(timestamp) }}
    </div>
  </div>
</template>

<script>
import drawDateTimeTable from "@/core/mixins/drawDateTimeTable.mixin";

export default {
  name: "DateTimeColumn",
  mixins: [drawDateTimeTable],
  props: {
    timestamp: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.history-time {
  font-weight: 400;
  font-size: 1.1em;
}
.history-date {
  font-weight: normal;
  color: rgba(0, 0, 0, 0.6);
}
</style>
